import React from 'react';
import { FaPhone, FaEnvelope, FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

const TopBar = () => {
    return (
        <div className="hidden md:block bg-gradient-to-r from-slate-900 via-blue-900 to-slate-900 text-white py-2.5 px-4 text-sm">
            <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2">
                {/* Contact Info */}
                <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
                    <a
                        href="tel:+12014099845"
                        className="flex items-center gap-2 hover:text-cyan-400 transition-colors duration-300"
                    >
                        <div className="w-6 h-6 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center">
                            <FaPhone size={10} />
                        </div>
                        <span className="font-medium">Call: +1 201-409-9845</span>
                    </a>
                    <a
                        href="mailto:info@nextgenltdco.com"
                        className="flex items-center gap-2 hover:text-cyan-400 transition-colors duration-300"
                    >
                        <div className="w-6 h-6 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-full flex items-center justify-center">
                            <FaEnvelope size={10} />
                        </div>
                        <span className="font-medium">info@nextgenltdco.com</span>
                    </a>
                </div>

                {/* Social Links */}
                <div className="flex items-center gap-1">
                    <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 hover:text-cyan-400 transition-all duration-300"
                    >
                        <FaFacebook size={14} />
                    </a>
                    <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 hover:text-cyan-400 transition-all duration-300"
                    >
                        <FaTwitter size={14} />
                    </a>
                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 hover:text-cyan-400 transition-all duration-300"
                    >
                        <FaInstagram size={14} />
                    </a>
                    <a
                        href="https://linkedin.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-white/10 hover:text-cyan-400 transition-all duration-300"
                    >
                        <FaLinkedin size={14} />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default TopBar;
